export function priceProject(value?: number): string | undefined {
    if (!value) return '0';
    let number = value.toFixed(2).toString();
    const decimals = 0;
    const decPoint = '.';
    const thousandsSep = ',';
    // Strip all characters but numerical ones.
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    const n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = typeof thousandsSep === 'undefined' ? ',' : thousandsSep,
        dec = typeof decPoint === 'undefined' ? '.' : decPoint,
        toFixedFix = function(n: number, prec: number) {
            const k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
    let s: string | string[] = '';

    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}
